import { useEffect, useReducer } from 'react';


/**
 * The given time while it is still ahead, else undefined. Re-renders once it passes, which no store change would.
 * @param time - The last moment of a hold, inclusive, as breakerHeldUntil gives it
 */
export const useTimeAhead = (time: number | undefined): number | undefined => {
  const [, passed] = useReducer((renders: number) => renders + 1, 0);
  const isAhead = time !== undefined && time >= Date.now();

  useEffect(() => {
    if (time === undefined || !isAhead) return;
    const timer = setTimeout(passed, time - Date.now() + 1);
    return () => clearTimeout(timer);
  }, [isAhead, time]);

  return isAhead ? time : undefined;
};
